export default {
  html: {
    fontSize: [`85%`, `90%`, `95%`, `100%`],
    scrollBehavior: `smooth`
  },
  'h1' : {
    fontSize: `1.8em!important;`
  },
  '#primaryArt' : {
    height: `95%`
  },
  '#inEditMode' : {
    fontSize: `15px`,
    lineHeight: `22px`
  },
  '#inEditMode .cmGoogBelowImage' : {
    minHeight: `auto`,
    paddingBottom: `0px`
  },
  '#inEditMode .cmSlideTitle': {
    marginBlockEnd: `0.3em`
  },
  '#inEditMode .cmSlideshowPixel': {
    display: `none`
  },
  '#inEditMode button': {
    cursor: `pointer`,
    backgroundColor: `blue`,
    color: `white`,
    padding: `15px`
  },
  '#inEditMode button:hover': {
    cursor: `pointer`,
    backgroundColor: `#EFEFEF`,
    color: `black`
  },
  '#inEditMode .cmSlideText': {
    marginBlockStart: `0em`,
    marginBlockEnd: `0em`
  },
  '#catScroll .st0': {
    fill: `currentColor!important`
  },
  '#catScroll svg': {
    fill: `currentColor`
  },
  '#catScroll span': {
    textTransform: `Capitalize`,
    minWidth: `100px`
  },
  '.cmLinks':{
    textDecoration: `none!important`
  },
  '::selection': {
    color: t => t.colors.white,
    background: t => t.colors.omegaDark
  },
  '.cm-content-frame': {
    width: `100%`,
    height: `calc(125vh - 92px)`,
    margin: `0 auto`,
    position: `absolute`,
    left: `0px`,
    border: `none`
  },
  '.gsib_a': {
    padding: `0px 9px 0px 9px!important`
  },
  '.gsc-search-button-v2': {
    padding: '7px 27px!important'
  },

  '.start-slideshow' : {
    width: `100%`,
    fontWeight: `900!important`,
    textTransform : `uppercase`,
    fontSize: `26px!important`,
    borderRadius: `8px!important`,
    boxShadow: `0px 0px 12px -2px rgba(0,0,0,0.5)`,
    transition: `background-color .6s ease`,
  },
  '.cmNexSlideBigBoy': {
    width: `100%`,
    fontWeight: `900!important`,
    textTransform : `uppercase`,
    fontSize: `26px!important`,
    borderRadius: `8px!important`,
    boxShadow: `0px 0px 12px -2px rgba(0,0,0,0.5)`,
    transition: `background-color .6s ease`,
  },
  '.cmCrazyArrows' : {
    fontSize: `38px!important`,
    color: `#2D3748`,
    animation: 'blinker 2s linear infinite',
    position: 'relative'
  },
  '@keyframes blinker':  {
    '50%' : {
      'opacity': 0
    }
  },
  '#cmSearch' : {
    width: `80%`,
    height: `100%`,
    margin: `0 auto`,
    border: `none`
  },
  '.cmSlideText': {
    fontSize: '20px',
    lineHeight: '32px'
  },
  '.slideShowEnabled .cmSlideTitle': {
    marginBlockStart: '-23px',
    marginBottom: '10px'
  },
  '.skiptranslate' :{
    display: 'none!important',
    height: '0px'
  },
  'body' : {
    top: '0px!important'
  },
  '.VIpgJd-ZVi9od-aZ2wEe-wOHMyf-ti6hGc' : {
    display: 'none!important',
  },
  '.in-iframe' : {
    display: 'none!important',
  },
  "#weatherSky": {
    backgroundImage: "url('/sky.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    width: "100%"
  },
  ".find-location": { position: "relative" },
  '.find-location input[type="text"]': {
    width: "100%",
    padding: "20px 50px 20px 20px",
    background: "#1e202b",
    color: "white",
    border: "2px solid white",
    fontWeight: "bold"
  },
  '.find-location input[type="submit"]': {
    position: "absolute",
    top: "5px",
    right: "5px",
    bottom: "5px",
    padding: "0 40px"
  },
  ".forecast-container": {
    width: ["100%", "100%"],
    background: "#fff",
    display: "table",
    tableLayout: "fixed",
    overflow: "hidden",
    borderRadius: "10px",
    marginBottom: "10px"
  },
  ".forecast-container .forecast": {
    display: "table-cell",
    verticalAlign: "top"
  },
  ".forecast-container .forecast:nth-child(even)": {
    backgroundColor: "#e0e0e0"
  },
  "@media screen and (max-width: 990px)": [
    {
      ".forecast-container .forecast": {
        display: "block",
        width: "100%",
        cssFloat: "left"
      }
    },
    {
      ".forecast-container .forecast.today": {
        display: "block",
        width: "100%",
        borderRadius: "13px 13px 0 0"
      }
    }
  ],
  ".forecast-container .forecast.today": { width: "420px" },
  ".forecast-container .forecast.today .forecast-header": { zoom: 1 },
  ".forecast-container .forecast.today .forecast-header:after": {
    content: '" "',
    clear: "both",
    display: "block",
    overflow: "hidden",
    height: "0"
  },
  ".forecast-container .forecast.today .forecast-header .day": {
    cssFloat: "left"
  },
  ".forecast-container .forecast.today .forecast-header .date": {
    cssFloat: "left"
  },
  ".forecast-container .forecast.today .forecast-content": {
    textAlign: "left",
    paddingTop: "30px",
    paddingBottom: "30px"
  },
  ".forecast-container .today h3": {
    fontSize: "93px",
    margin: "0px",
    lineHeight: "90px"
  },
  ".forecast-condition": { textTransform: "uppercase" },
  ".forecast-container .forecast.today .location": {
    fontSize: ["18px", "1.2857142857em"],
    fontWeight: 400
  },
  ".forecast-container .forecast.today .degree .num, .forecast-container .forecast.today .degree .forecast-icon": {
    display: "inline-block",
    verticalAlign: "middle"
  },
  ".forecast-container .forecast.today .degree .num": {
    fontSize: ["90px", "6.4285714286rem"],
    marginRight: "30px"
  },
  ".forecast-container .forecast.today span": { marginRight: "20px" },
  ".forecast-container .forecast.today span img": {
    marginRight: "5px",
    verticalAlign: "middle"
  },
  ".forecast-container .forecast .forecast-header": {
    background: "rgba(0, 0, 0, 0.1)",
    padding: "10px",
    textAlign: "center",
    fontWeight: 700
  },
  ".forecast-container .forecast .forecast-icon": { height: "100px" },
  ".forecast-container .forecast .forecast-content": {
    padding: "50px 20px 10px",
    textAlign: "center"
  },
  ".forecast-container .forecast .forecast-content .forecast-icon": {
    marginBottom: "20px"
  },
  ".forecast-container .forecast .forecast-content .degree": {
    fontSize: ["24px", "1.7142857143em"],
    color: "#1e202b",
    fontWeight: 700
  },
  ".forecast-container .forecast .forecast-content small": {
    fontSize: ["16px", "1.1428571429em"]
  },
  ".fullwidth-block": {},
  ".location-prompt": {
    display: "none",
    flexFlow: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    background: "#009ad8",
    top: "0",
    padding: "5px",
    color: "white",
    fontSize: "15px",
    position: "fixed",
    zIndex: 99
  },
  "#location-button": { borderRadius: "7px" },
  "#hto .logo_def, #hto .logo_retina": { height: "50px" },
  ".optionset li a": { fontSize: "14px" },
  ".spinner-container": {
    margin: "0 auto",
    fontSize: "19px",
    textAlign: "center"
  },
  ".spinner-container span": { fontSize: "14px" },
  "@keyframes spinner": {
    "0%": { transform: "rotate(0deg)" },
    "100%": { transform: "rotate(360deg)" }
  },
  ".loading-spinner": {
    width: "50px",
    height: "50px",
    border: "10px solid #f3f3f3",
    borderTop: "10px solid #1e202b",
    borderRadius: "50%",
    animation: "spinner 1.5s linear infinite",
    margin: "0 auto"
  },
  ".cmGoogAdsSidebar" : {
    width: "100%",
    minHeight : "251px",
    paddingBottom: "10px",
    minWidth: "300px"
  },
  ".cmGoogAdsSidebar ins" : {
    width: "100%",
    minHeight : "251px"
  },
  ".cmGoogBelowImage" : {
    width: "100%",
    minHeight : "91px",
    paddingBottom: "10px",
    marginTop: "2px"
  },
  ".cmGoogBelowImage ins" : {
    width: "100%"
  },
  ".cmGoogBelowImagePrimaryArt" : {
    width: "100%",
    minHeight : "91px",
    paddingBottom: "5px",
    marginTop: "5px",
    height: "auto"
  },
  ".cmGoogBelowImagePrimaryArt ins" : {
    width: "100%",
    minHeight: "171px"
  },
  ".cmGoogButtonHugger" : {
    width: "100%",
    margin: `6px 0px!important`,
    height: "465px"
  },
  ".cmGoogButtonHugger ins" : {
    width: "100%",
    height: '465px'
  },
  ".cmSlideshowImage" : {
    width: "100%"
  },
  ".dark .rc-headline": {
    color: "#fff!important"
  },
  ".cmRcWrap": {
    width: "100%",
    minHeight: "100px"
  },
  "#cmGutterContainer": {
    position: "relative",
    width: "100%",
    height: "10px"
  },
  "#cmGutterContainer div": {
    opacity: ".01"

  },
  "#cmGutterLeft300": {
    display: 'none',
  },
  "#cmGutterRight300": {
    display: 'none',
  },
  "#cmGutterLeft160": {
    display: 'none',
  },
  "#cmGutterRight160": {
    display: 'none',
  },
  "@media (min-width: 1700px)": {
    "#cmGutterLeft300": {
      position: 'absolute',
      width: '300px',
      height: '200vh',
      backgroundColor: 'red',
      left: '-320px',
      top: '-60px',
      display: 'block'
    },"#cmGutterRight300": {
      position: 'absolute',
      width: '300px',
      height: '200vh',
      backgroundColor: 'red',
      right: '-320px',
      top: '-60px',
      display: 'block'
    }
  },
  "@media (min-width: 1400px) and (max-width: 1699px)": {
    "#cmGutterLeft160": {
        position: 'absolute',
        width: '160px',
        height: '200vh',
        backgroundColor: 'blue',
        left: '-180px',
        top: '-60px',
        display: 'block'
  },"#cmGutterRight160": {
        position: 'absolute',
        width: '160px',
        height: '200vh',
        backgroundColor: 'blue',
        right: '-180px',
        top: '-60px',
        display: 'block'
    }
  },

  "@media only screen and (max-width: 768px)": {
    ".css-1yus8ce" : {
      padding: '1.1rem 0!important'
    },
    ".css-bh18vc" : {
      paddingLeft: '0.5rem!important',
      paddingRight: '0.5rem!important',
      overflow: 'hidden'
    }
  }




}
